import { useContext } from "react";

import { CurrencyContext } from "Intl/Context/CurrencyProvider";

export function useCurrency() {
  return useContext(CurrencyContext);
}
